import ConflictGroup from '../schema/ConflictGroup';
import NormalisedEvent from '../schema/NormalisedEvent';
import { compare } from 'owa-datetime';

/**
 * Given a listed of temporally custom ordered events, this returns a list of conflict groups for the given events
 * Events which do not conflict with any other events are considered
 * @param events
 */
const orderedEventListToConflictGroupList = (events: NormalisedEvent[]): ConflictGroup[] => {
    const groups: ConflictGroup[] = [];

    // Since in every iteration we will be modifying the input list of events, we clone it at first
    const remainingEvents: NormalisedEvent[] = [...(events || [])];

    while (remainingEvents.length) {
        /**
         * Create a candidate conflict group with the first of the remaining events
         * Then iterate through all the remaining items to determine which of them can potentially be added into this
         * particular conflict group.
         * If there is no other overlap, then the candidate conflict group just contains the single event as the lone wolf  */

        // get the first of the remaining items
        const selectorEvent: NormalisedEvent = remainingEvents.shift();

        // initiate a candidateGroup
        const candidateGroup: ConflictGroup = {
            start: selectorEvent.start,
            end: selectorEvent.end,
            events: [selectorEvent],
        };

        let currentEventIndex: number = 0;

        while (currentEventIndex < remainingEvents.length) {
            const currentEvent: NormalisedEvent = remainingEvents[currentEventIndex];

            if (
                compare(currentEvent.start, candidateGroup.end) >= 0 ||
                compare(candidateGroup.start, currentEvent.end) >= 0
            ) {
                currentEventIndex++;
            } else {
                // In case of an overlap, include the event and remove it from the remaining list of items
                candidateGroup.events.push(currentEvent);
                candidateGroup.start =
                    compare(candidateGroup.start, currentEvent.start) === -1
                        ? candidateGroup.start
                        : currentEvent.start;
                candidateGroup.end =
                    compare(candidateGroup.end, currentEvent.end) === 1
                        ? candidateGroup.end
                        : currentEvent.end;
                remainingEvents.splice(currentEventIndex, 1);

                // Since an item has been removed, do not increment the index
            }
        }

        // Add the new group
        groups.push(candidateGroup);
    }

    return groups;
};

export default orderedEventListToConflictGroupList;
